import { render, staticRenderFns } from "./cube_3.vue?vue&type=template&id=7780348d&scoped=true&"
import script from "./cube_3.vue?vue&type=script&lang=js&"
export * from "./cube_3.vue?vue&type=script&lang=js&"
import style0 from "./cube_3.vue?vue&type=style&index=0&id=7780348d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7780348d",
  null
  
)

export default component.exports